import styled from '@emotion/styled'

const Button = styled.button`
  background-color: #75b09c;
  border: none;
  border-radius: 4px;
  box-shadow: none;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
  font-weight: 400;
  line-height: 42px;
  height: 42px;
  padding: 0 30px;
  box-sizing: border-box;
  text-decoration: none;

  :disabled {
    background-color: #999999;
  }
`

export default Button